import { Base } from './base'
import { Interface } from '@/models/interface'
import { PlcDevice } from '@/models/plc-device'
import { ModbusDevice } from '@/models/modbus-device'
import { AnalogDevice } from '@/models/analog-device'
import { Dlt645Device } from '@/models/dlt645-device'
import Joi from 'joi'

/* FIXME: should generate from backend */
const INTERFACE = {
  ADC: {
    name: 'ADC 接口',
    parameters: [
      {
        key: 'port',
        label: '设备 ID',
        type: 'string'
      }
    ]
  },
  RS232: {
    name: 'RS232 接口',
    parameters: [
      {
        key: 'port',
        label: '设备 ID',
        type: 'string'
      },
      {
        key: 'baudRate',
        label: '波特率',
        type: 'number'
      },
      {
        key: 'dataBits',
        label: '数据位',
        type: 'number'
      },
      {
        key: 'stopBits',
        label: '停止位',
        type: 'number'
      },
      {
        key: 'parity',
        label: '校验方式',
        type: 'select',
        options: [
          {
            key: 'none (无校验)',
            value: 'none'
          },
          {
            key: 'odd (奇校验)',
            value: 'odd'
          },
          {
            key: 'even (偶校验)',
            value: 'even'
          }
        ]
      }
    ]
  },
  RS485: {
    name: 'RS485 接口',
    parameters: [
      {
        key: 'port',
        label: '设备 ID',
        type: 'string'
      },
      {
        key: 'baudRate',
        label: '波特率',
        type: 'number'
      },
      {
        key: 'dataBits',
        label: '数据位',
        type: 'number'
      },
      {
        key: 'stopBits',
        label: '停止位',
        type: 'number'
      },
      {
        key: 'parity',
        label: '校验方式',
        type: 'select',
        options: [
          {
            key: 'none (无校验)',
            value: 'none'
          },
          {
            key: 'odd (奇校验)',
            value: 'odd'
          },
          {
            key: 'even (偶校验)',
            value: 'even'
          }
        ]
      }
    ]
  },
  'USB-UART': {
    name: 'USB-UART 接口',
    parameters: [
      {
        key: 'path',
        label: '设备路径',
        type: 'string'
      },
      {
        key: 'baudRate',
        label: '波特率',
        type: 'number'
      },
      {
        key: 'dataBits',
        label: '数据位',
        type: 'number'
      },
      {
        key: 'stopBits',
        label: '停止位',
        type: 'number'
      },
      {
        key: 'parity',
        label: '校验方式',
        type: 'select',
        options: [
          {
            key: '无校验',
            value: 'none'
          },
          {
            key: '奇校验',
            value: 'odd'
          },
          {
            key: '偶校验',
            value: 'even'
          }
        ]
      }
    ]
  },
  NET: {
    name: '网络接口',
    parameters: [
      /*
      {
        key: 'ip',
        label: '网卡 IP 地址',
        type: 'string'
      }
      */
    ]
  }
}

export class InterfaceManager extends Base {
  constructor (vueComponent) {
    super(vueComponent)

    this._interfaceConfig = INTERFACE

    this._interface = new Interface()
    this._plcDevice = new PlcDevice()
    this._modbusDevice = new ModbusDevice()
    this._analogDevice = new AnalogDevice()
    this._dlt645Device = new Dlt645Device()

    this._operationMap = {
      interface: {
        add: this._addInterface
      },
      interfaceInstance: {
        click: this._inspectInstance,
        edit: this._editInstance,
        remove: this._removeInstance
      }
    }

    this._addListeners()
  }

  async genTreeData () {
    return [
      {
        id: 'root-node1',
        name: 'ADC 接口',
        operations: [ 'add' ],
        children: await this._genChildren('ADC'),
        class: 'interface',
        type: 'ADC'
      },
      {
        id: 'root-node2',
        name: 'RS485 总线接口',
        operations: [ 'add' ],
        children: await this._genChildren('RS485'),
        class: 'interface',
        type: 'RS485'
      },
      {
        id: 'root-node3',
        name: 'RS232 接口',
        operations: [ 'add' ],
        children: await this._genChildren('RS232'),
        class: 'interface',
        type: 'RS232'
      },
      {
        id: 'root-node4',
        name: 'USB-UART 接口',
        operations: [ 'add' ],
        children: await this._genChildren('USB-UART'),
        class: 'interface',
        type: 'USB-UART'
      },
      {
        id: 'root-node5',
        name: '网络接口',
        operations: [ 'add' ],
        children: await this._genChildren('NET'),
        class: 'interface',
        type: 'NET'
      }
    ]
  }

  async processOperation (operation, data) {
    let cb = this._operationMap[data.class][operation]

    await cb.call(this, data)
  }

  async _addInterface (iface) {
    let cfg = this._interfaceConfig[iface.type]

    this._requestForm('interface', {
      name: '',
      type: iface.type,
      parameters: cfg.parameters,
      args: {}
    })
  }

  async _inspectInstance (ins) {
    let data = await this._interface.get(ins.id)

    this._requestForm('interface', {
      name: data.name,
      type: data.type,
      args: data.args,
      parameters: this._interfaceConfig[data.type].parameters
    }, false)
  }

  async _editInstance (ins) {
    let data = await this._interface.get(ins.id)

    this._requestForm('interface', {
      _id: ins.id,
      name: data.name,
      type: data.type,
      args: data.args,
      parameters: this._interfaceConfig[data.type].parameters
    }, true, 'updateInterface')
  }

  async _removeInstance (ins) {
    await this._interface.delete(ins.id)

    this.alertSuccess('删除成功')
  }

  async _genChildren (type) {
    let list = await this._interface.all(type)
    let children = []

    for (let index in list) {
      let iface = list[index]

      children.push({
        name: iface.name,
        operations: [ 'click', 'remove', 'edit' ],
        class: 'interfaceInstance',
        id: iface.id,
        children: await this._getDeviceByInterfaceId(iface.id)
      })
    }

    return children
  }

  async _getDeviceByInterfaceId (id) {
    let arr = []
    const models = [
      this._plcDevice,
      this._analogDevice,
      this._modbusDevice,
      this._dlt645Device
    ]

    await Promise.all(models.map(async model => {
      const devices = await model.interfaceId(id)
      arr = arr.concat(devices.map(device => {
        return {
          name: device.name
        }
      }))
    }))

    return arr
  }

  get _adcSchema () {
    return {
      port: Joi.string().required()
    }
  }

  get _rs232Schema () {
    return {
      port: Joi.string().required(),
      baudRate: Joi.number().required(),
      dataBits: Joi.number().required(),
      stopBits: Joi.number().required(),
      parity: Joi.string().required()
    }
  }

  get _usbUartSchema () {
    return {
      path: Joi.string().required(),
      baudRate: Joi.number().required(),
      dataBits: Joi.number().required(),
      stopBits: Joi.number().required(),
      parity: Joi.string().required()
    }
  }

  get _netSchema () {
    return {}
  }

  get _schemaMap () {
    return {
      'ADC': this._adcSchema,
      'RS232': this._rs232Schema,
      'RS485': this._rs232Schema,
      'USB-UART': this._usbUartSchema,
      'NET': this._netSchema
    }
  }

  _verifyInterface (data) {
    if (typeof data.name !== 'string' || !data.name) {
      throw new Error('Invalid interface name')
    }

    if (data._id && typeof data._id !== 'string') {
      throw new Error(`Invliad _id: '${data._id}'`)
    }

    const schema = this._schemaMap[data.type]
    if (!schema) {
      throw new Error(`Invliad interface type: '${data.type}'`)
    }

    const res = Joi.validate(data.args, schema)
    if (res.error) {
      throw res.error
    }

    data.args = res.value

    return data
  }

  async _addListeners () {
    this._addFormListener('interface', async data => {
      const value = this._verifyInterface(data)

      await this._interface.add(value)

      this.alertSuccess('保存成功')
    })

    this._addFormListener('updateInterface', async data => {
      const value = this._verifyInterface(data)

      await this._interface.update(data._id, value)

      this.alertSuccess('修改成功')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/home/controllers/interface.js